import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MembersTableBlock } from './components/MembersTableBlock';
import { MembersStatsSidebar } from './components/MembersStatsSidebar';
import { MembersToolbar } from './components/MembersToolbar';
import { useMembersList } from './hooks/useMembersList';
import type { Member } from './types/membersList.types';

const pageSize = 10;

export function MembersListPage() {
  const navigate = useNavigate();
  const {
    members,
    invitations,
    stats,
    distribution,
    filters,
    isLoading,
    setFilters,
  } = useMembersList();

  const [currentPage, setCurrentPage] = useState(1);

  const paginatedMembers = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return members.slice(start, start + pageSize);
  }, [members, currentPage]);

  const handleEdit = (member: Member) => {
    navigate(`?tab=members-edit&id=${member.id}`);
  };

  const handleDelete = (member: Member) => {
    // Implement delete logic or confirm dialog
    console.log('Delete member:', member.id);
  };

  const handleToggleStatus = (member: Member) => {
    // Implement toggle status logic
    console.log('Toggle status:', member.id);
  };

  return (
    <div className="space-y-4">
      <MembersToolbar
        filters={filters}
        onChange={setFilters}
        onAdd={() => navigate('?tab=members-new')}
        onExport={() => console.log('Export members')}
      />

      <div className="space-y-4">
        <MembersTableBlock
          members={paginatedMembers}
          isLoading={isLoading}
          currentPage={currentPage}
          pageSize={pageSize}
          totalItems={members.length}
          onPageChange={setCurrentPage}
          onAdd={() => navigate('?tab=members-new')}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onToggleStatus={handleToggleStatus}
          onViewDetail={(member) => navigate(`?tab=members-detail&id=${member.id}`)}
        />
      </div>
    </div>
  );
}
